"use client";

import { PdpCtx } from "@/providers/PdpProvider";
import React, { useState } from "react";

interface IProps {
  children?: React.ReactNode;
  initialLensSelectionTabIndex?: number;
}

export interface PdpDataType {
  selectedVariant?: string;
  selectedPower?: {
    leftEye?: string;
    rightEye?: string;
  };
  productDetailsTab?: string;
  sizeAndFitChildTab?: number; // 0 for Measurements & Fit, 1 for Size Guide
}

const PdpLayout = ({ children, initialLensSelectionTabIndex }: IProps) => {
  const [pdpData, setPdpData] = useState<PdpDataType>({});
  const [lensSelectionTabIndex, setLensSelectionTabIndex] = useState(
    initialLensSelectionTabIndex ?? 0,
  );
  return (
    <PdpCtx.Provider
      value={{
        pdpData,
        setPdpData,
        lensSelectionTabIndex,
        setLensSelectionTabIndex,
      }}
    >
      {children}
    </PdpCtx.Provider>
  );
};

export default PdpLayout;
